const toFloat = (val) => {
  let value = parseFloat(val);
  if (!isNaN(value)) {
    return value;
  } else {
    return 0;
  }
};

const formatMoney = (value, fixed = 2) => {
  if (value === null) return value;
  const money = typeof value === "string" ? Number(value) : value;
  const val = toFixedTrunc(parseFloat(Number.isFinite(money) ? money : 0), fixed);
  return val.trim();
}

function toFixedTrunc(number, fixed) {
  const value = number.toString().split(".");
  if (fixed <= 0) return value[0];
  let tenths = value[1] || "";
  if (tenths.length > fixed) return `${value[0]}.${tenths.substr(0, fixed)}`;
  while (tenths.length < fixed) tenths += "0";
  return `${value[0]}.${tenths}`;
}

function openNewTabWithFilter (pathname, filter) {
  const origin = window.location.origin;
  const url = origin + pathname + `?filter=${ filter }`;
  return window.open(url, '_blank');
}

export {
  toFloat,
  formatMoney,
  openNewTabWithFilter
};
